/*
 * Copyright 2026 Mifos Initiative
 *
 * This Source Code Form is subject to the terms of the Mozilla Public
 * License, v. 2.0. If a copy of the MPL was not distributed with this
 * file, You can obtain one at https://mozilla.org/MPL/2.0/.
 *
 * See https://github.com/openMF/kmp-project-template/blob/main/LICENSE
 */
package kpt.core.base.database

/**
 * Per-fork database naming, generated by `syncForkConfig` from `app-profile/app.yaml`
 * (`identity.app_id` / `identity.app_name`).
 *
 * INFRA (owner: template). A fork never hand-writes these — the generated
 * `kpt.core.database.DatabaseConfig` supplies both values and threads them into
 * [platformDatabaseModule] so the on-disk DB file and the desktop data directory are
 * unique per fork (two template-derived apps never collide on shared storage) without
 * any consumer touching platform builder code.
 *
 * @property fileName On-disk SQLite file name, e.g. `"org_mifos_kmp_template.db"`.
 * @property desktopDirName Desktop (JVM) parent directory under the OS app-data root,
 *   e.g. `"MifosMoneyToolkit"`. Ignored on non-desktop targets.
 */
class DatabaseNaming(
    val fileName: String,
    val desktopDirName: String,
)
